import { FaCarSide } from "react-icons/fa";
import { BiSolidBox } from "react-icons/bi";
import { BsFillPersonFill } from "react-icons/bs";
//#region src/modules/Records/shared/record-icons.ts
var recordIcons = {
	item: BiSolidBox,
	person: BsFillPersonFill,
	vehicle: FaCarSide
};
//#endregion
export { recordIcons };

//# sourceMappingURL=record-icons.js.map